import { render, staticRenderFns } from "./newUser.vue?vue&type=template&id=cac5a44c&scoped=true"
import script from "./newUser.vue?vue&type=script&lang=js"
export * from "./newUser.vue?vue&type=script&lang=js"
import style0 from "./newUser.vue?vue&type=style&index=0&id=cac5a44c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac5a44c",
  null
  
)

export default component.exports